import { createNamedContext } from '@/utils';
import type { ContextValue } from './interfaces';

export const TabViewContext = createNamedContext<ContextValue>(undefined, 'TabView.Context');